export enum BI_RSVP_STATUS {
  YES = 'Yes',
  NO = 'No',
  WAITING = 'Waiting',
}
